function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'arctix-clear': 'url("//www.iwearhyspecs.com/cdn/shop/files/arctix-clear_68x.png?v=15293061090084720470")','barely-pink': 'url("//www.iwearhyspecs.com/cdn/shop/files/barely-pink_68x.png?v=16218802737066414676")','butter-rum': 'url("//www.iwearhyspecs.com/cdn/shop/files/butter-rum_68x.png?v=13820756523803734381")','clay': 'url("//www.iwearhyspecs.com/cdn/shop/files/clay_68x.png?v=18037592140529090891")','iron-grey': 'url("//www.iwearhyspecs.com/cdn/shop/files/iron-grey_68x.png?v=9740571040668454309")','matte-black': 'url("//www.iwearhyspecs.com/cdn/shop/files/matte-black_68x.png?v=14138560084729015597")','m-black': 'url("//www.iwearhyspecs.com/cdn/shop/files/m-black_68x.png?v=9585371291371151019")','tactic': 'url("//www.iwearhyspecs.com/cdn/shop/files/tactic_68x.png?v=6818049269458536358")','atomic-yellow': 'url("//www.iwearhyspecs.com/cdn/shop/files/Atomic_Yellow_68x.png?v=392711696063637826")','teal-eyes-on-the-trades-edition': 'url("//www.iwearhyspecs.com/cdn/shop/files/teal_color_68x.png?v=8587546840204551901")','tidal-grey-heatshield-lenses': 'url("//www.iwearhyspecs.com/cdn/shop/files/tidal_grey_68x.png?v=2129595106464153511")','tidal-grey': 'url("//www.iwearhyspecs.com/cdn/shop/files/tidal_grey_68x.png?v=2129595106464153511")','lilac': 'url("//www.iwearhyspecs.com/cdn/shop/files/lilac_68x.png?v=2683643771786757196")','ash': 'url("//www.iwearhyspecs.com/cdn/shop/files/ash_68x.png?v=16522668250017239008")',};

    this.triggers = ['color','colour','couleur','farbe','cor','frame colours','choose frame colour',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
